import { doc, deleteDoc } from 'firebase/firestore'
import { db } from '../firebase'
import { useState } from 'react'
import { getCollectionName } from './useProjects'
import { useTheme } from '../context/ThemeContext'

/**
 * Hook for deleting projects or tasks from Firebase
 * @returns {[boolean, (listType: 'projects' | 'tasks', id: string) => Promise<void>, Error | null]}
 */
export const useDelete = () => {
  const [isDeleting, setIsDeleting] = useState(false)
  const [error, setError] = useState(null)
  const { theme } = useTheme()

  const deleteItem = async (listType, id) => {
    setIsDeleting(true)
    setError(null)

    try {
      const docRef = doc(db, getCollectionName(listType, theme), id)
      await deleteDoc(docRef)
    } catch (err) {
      setError(err)
      console.error('Error deleting document:', err)
    } finally {
      setIsDeleting(false)
    }
  }

  return [isDeleting, deleteItem, error]
}
